import Vue from 'vue'
import {
  getDatePattern,
  getDatetimePattern,
  formatDatetimeWithSeconds,
  formatDatetime,
  formatDate,
  formatTime,
  formatTimeWithSeconds,
  adjustDateWithTimezone,
} from '@/utils/dates.js'

export { frenchDatePattern, englishTimePattern } from '@/utils/dates.js'

Vue.use(CreateI18nDateFormatterVuePlugin())

export default function CreateI18nDateFormatterVuePlugin() {
  return {
    install: function () {
      Vue.$date = Vue.prototype.$date = {
        getDatePattern,
        getDatetimePattern,
        formatDatetimeWithSeconds,
        formatDatetime,
        formatDate,
        formatTime,
        formatTimeWithSeconds,
        adjustDateWithTimezone,
      }
    },
  }
}
